import Api from './Api';

export default class FaqsApi {

    all = async () => {
        return await Api.get(`faqs`).then(response => {
            return response.data;
        }).catch((error) => console.log('[FaqsApi]: Error\n', error));
    };

    categorias = async () => {
        return await Api.get('faqscategorias').then(response => {
            return response.data;
        }).catch(error => console.log('[FaqsApi][categorias]: Error\n', error));
    };

    getByCategoria = async (categoria_id) => {
        return await Api.get(`faqs/categorias/${categoria_id}`).then(response => {
            return response.data;
        });
    };

    pesquisar = async (pesquisa) => {
        return await Api.get(`faqs/pesquisar/${pesquisa}`).then(response => {
            return response.data;
        }).catch(error => console.log('[FaqsApi][pesquisar]: Error\n', error));
    };
}